import React, { useState } from "react";

function ImageWithSpinner({ src, alt }) {
  const [isLoaded, setIsLoaded] = useState(false);
  if (src === undefined) return null; // Protect
  return (
    <div className="relative w-full h-full">
      {!isLoaded && (
        <div className="absolute inset-0 flex items-center justify-center">
          {/* This is a simple spinner using TailwindCSS */}
          <div className="w-2 h-2 border-4 border-blue-600 rounded-full loader-small border-t-transparent animate-spin"></div>
        </div>
      )}
      <img
        src={src}
        alt={alt}
        className={`w-full h-full ${
          isLoaded ? "block" : "hidden"
        } rounded-lg hover:shadow-lg`}
        onLoad={() => setIsLoaded(true)}
        style={isLoaded ? {} : { display: "none" }}
      />
    </div>
  );
}

export default ImageWithSpinner;
